module.exports = __webpack_public_path__ + "img/img3.065f7c29.png";